export default {
  meta: {
    title: '洞察列表',
  },
};
